const {gql} = require('graphql-tag')
export default gql`
  mutation createFilmMasterPosterFrames ($input: FilmMasterPosterFrameInputs!) {
    createFilmMasterPosterFrames (input: $input) {
      artworkID
    }
  }
`
